import * as React from 'react';
/**
 *
 * Original name: strikethrough
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=1%3A169
 *
 */
export const StrikethroughLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M18 11.5h-6c-1.368 0-3-.39-3-2.25C9 7.788 10.546 7 12 7c1.384 0 3 .524 3 2h1.5c0-2.093-1.809-3.5-4.5-3.5-2.566 0-4.5 1.612-4.5 3.75-.02.812.238 1.606.732 2.25H6V13h6c1.368 0 3 .39 3 2.25 0 1.24-1.345 2.25-3 2.25-1.384 0-3-.523-3-2H7.5c0 2.093 1.809 3.5 4.5 3.5 2.524 0 4.5-1.647 4.5-3.75a3.546 3.546 0 0 0-.732-2.25H18v-1.5Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
